export default function Footer() {
  return (
    <footer className="bg-black text-white py-16 border-t-4 border-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <img 
                src="https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/550d2e7295433d49905bc8b37a9be776.png" 
                alt="FREE SKI ORELLE" 
                className="h-24 w-auto"
              />
              <img 
                src="https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/78cbdae630ee573145ac8da1396b3265.png" 
                alt="ESF ORELLE" 
                className="h-24 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed font-light mb-6">
              Votre club de ski spécialisé en freestyle, freeride, sécurité et préparation physique au cœur des Trois Vallées.
            </p>
            <a 
              href="mailto:contact@esf-orelle.fr?subject=Don pour Orelle Freeski" 
              className="inline-flex items-center justify-center bg-white text-black px-6 py-3 font-bold hover:bg-gray-200 transition-all cursor-pointer whitespace-nowrap tracking-wide uppercase text-sm"
            >
              <i className="ri-heart-line mr-2"></i>
              Faire un Don
            </a>
          </div>

          <div>
            <h5 className="text-lg font-black mb-6 uppercase tracking-wide">Nos Services</h5>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer font-light">
                  Sécurité en Montagne
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer font-light">
                  Freeride
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer font-light">
                  Freestyle
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer font-light">
                  Préparation Physique
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-black mb-6 uppercase tracking-wide">Contact</h5>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <div className="w-8 h-8 flex items-center justify-center bg-white text-black">
                  <i className="ri-phone-line"></i>
                </div>
                <a 
                  href="tel:+33479567411" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer font-light"
                >
                  +33 4 79 56 74 11
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-8 h-8 flex items-center justify-center bg-white text-black">
                  <i className="ri-mail-line"></i>
                </div>
                <a 
                  href="mailto:contact@esf-orelle.fr" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer font-light"
                >
                  contact@esf-orelle.fr
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-8 h-8 flex items-center justify-center bg-white text-black">
                  <i className="ri-map-pin-line"></i>
                </div>
                <span className="text-gray-400 font-light">Orelle, Savoie</span>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-8 h-8 flex items-center justify-center bg-white text-black">
                  <i className="ri-mountain-line"></i>
                </div>
                <span className="text-gray-400 font-light">Les Trois Vallées</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0 font-light">
            © 2024 Orelle Freeski. Tous droits réservés.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer font-light"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}